import React, { useCallback, useState } from 'react';
import { RadioChangeEvent } from 'antd';

import { orderUpdatePurchasableOffPlatform } from 'api/order_sdk';

import { Modal, Radio, RadioGroup } from 'ui-kit';

export interface IAirbnbResolutionCenterModal {
  isOpen: boolean;
  orderId: number;
  initalIsPurchasableOffPlatform: boolean | undefined;
  onUpdate: () => void;
}

const AirbnbResolutionCenterModal = ({
  isOpen,
  orderId,
  initalIsPurchasableOffPlatform,
  onUpdate,
}: IAirbnbResolutionCenterModal) => {
  const [isPurchasableOffPlatform, setIsPurchasableOffPlatform] = useState<undefined | boolean>(
    initalIsPurchasableOffPlatform,
  );

  const handleChangeIsPurchasableOffPlatform = useCallback(
    (event: RadioChangeEvent) => setIsPurchasableOffPlatform(event.target.value),
    [],
  );

  const handleConfirm = useCallback(() => {
    orderUpdatePurchasableOffPlatform({
      orderId,
      isPurchasableOffPlatform,
    }).then(() => {
      onUpdate();
    });
  }, [orderId, isPurchasableOffPlatform, onUpdate]);

  return (
    <Modal
      visible={isOpen}
      onOk={handleConfirm}
      title="Was your reservation made on the Airbnb platform?"
      onCancel={onUpdate}
    >
      <RadioGroup value={isPurchasableOffPlatform} onChange={handleChangeIsPurchasableOffPlatform}>
        <div>
          <Radio value={true}>Yes</Radio>
          <Radio value={false}>No</Radio>
        </div>
      </RadioGroup>
    </Modal>
  );
};

export default AirbnbResolutionCenterModal;
